import * as React from "react";
import { Badge } from "components/bootstrap";
const RATING_STYLES = {
  CRITICAL: "danger",
  HIGH: "warning",
  MEDIUM: "primary",
  LOW: "gray"
};
function CVSSHeatBadge({ rating }) {
  if (!rating) return null;
  return /* @__PURE__ */ React.createElement(Badge, { color: RATING_STYLES[rating] }, rating);
}
export default CVSSHeatBadge;
